export const componentStyles = {
  inputStyle: { border: "1px solid #809FB8", marginTop: "5px", color: "black", backgroundColor: "white"},
  selectStyle: { border: "1px solid #809FB8", borderRadius: "10px", boxShadow: "none" },
  rowStyle: { display: "flex", justifyContent: "start", gap: "15%" },
  headingStyle: { color: "#476788", fontSize: "42px", marginBottom: "43px", marginRight: "82px" },
  headingStyleProfile: { color: "#476788",fontSize: "28px"},
  backButton: { border: "none", backgroundColor: "transparent", boxShadow: "none" },
  rowStyling: { justifyContent: "center" },
  buttonColStyling: { display: "flex", justifyContent: "flex-end", marginTop: "30px" },
  marginRight: { marginRight: "10px" },
  cancelButtonStyle: {
    width: "124px",
    height: "42px",
    borderRadius: "6px",
    border: "1px solid #809FB8",
  },
  saveButtonStyle: {
    width: "124px",
    height: "42px",
    borderRadius: "6px",
    background: "#6AAEBA",
    color: "white",
    border: "none",
    fontWeight: "bold",
  },
  labelStyle: {
    fontWeight: 700,
    fontSize: "16px",
    color: "#809FB8",
  },
  additionalServices: {
    borderRadius: "6px",
    background: "#6AAEBA",
    color: "white",
    border: "none",
    fontWeight: "bold",
  },
  popUp: {
    position: "fixed",
    top: "27%",
    left: "52%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "500px",
    minWidth: "300px",
    padding: "20px",
    boxSizing: "border-box",
    zIndex: 1000,
  },
  popInner: {
    background: "white",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 0 15px rgba(0, 0, 0, 0.3)", 
  },
  requiredInput: {
    color: "rgb(235, 105, 101)",
  },
  multiSelectContainer: {
    marginBottom: "20px",
  },
  crossTag: {
    width: "20px", 
    height: "20px",
    marginLeft: "5px",
    backgroundColor: "#ccc",
    color: "#e6006e",
    border: "none",
    borderRadius: "50%", 
    cursor: "pointer", 
  },
  popupTitle: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "15px",
    textAlign: "center", 
  },
  formField: {
    marginBottom: "15px", 
  },
  formLabel: {
    display: "block", 
    marginBottom: "5px", 
    fontWeight: "bold",
  },
  formInput: {
    width: "100%",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  formButton: {
    padding: "10px 20px",
    borderRadius: "4px",
    border: "none",
    background: "#ff007f",
    color: "white",
    fontWeight: "bold",
    cursor: "pointer",
    marginRight: "10px",
  },
  cancelButton: {
    padding: "10px 20px",
    borderRadius: "4px",
    border: "none",
    background: "#ccc",
    color: "#333",
    cursor: "pointer",
  },
  formButtonGetToKnowYou: {
    padding: "10px 20px",
    borderRadius: "4px",
    border: "none",
    background: "#40a9ff",
    color: "white",
    fontWeight: "bold",
    cursor: "pointer",
    marginRight: "10px",
  },
  uploadContainer: {
    position: 'relative',
    width: '100px',
    height: '100px',
  },
  fileInput: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    opacity: 0,
    zIndex: 2,
  },
  imageContainer: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
  },
  profileImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  defaultImage: {
    // width: '60%',
    // height: '60%',
    transition: 'opacity 0.3s ease',
    position: 'absolute',
  },
  uploadOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(24, 144, 255, 0.1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadIcon: {
    fontSize: '24px',
    color: '#1890ff',
  },
  spinnerOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};
